import DOMPurify from 'dompurify';

/**
 * sanitizeHtml — the one place email HTML is made safe to render in the app.
 *
 * A template preview is server-rendered HTML the operator may also have edited by hand, and it
 * lands in the page through `dangerouslySetInnerHTML`. DOMPurify strips scripts, event handlers,
 * javascript: URLs and the like while keeping the tables and inline styles the email body relies
 * on. Use this on ANY HTML string that reaches innerHTML, never the raw string.
 */
export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, { USE_PROFILES: { html: true }, FORBID_TAGS: ['style', 'iframe', 'object', 'embed', 'form'], FORBID_ATTR: ['srcdoc'] });
}
